/*
 * Breakpoints shared between the banner components and the stylesheet.
 * Keep this in sync with the SIDE BANNER RAILS media query at the end of
 * _asset/css/circus.css.
 */

/** Matches `$device_lg` (1060px) — the project's own desktop/mobile switch. */
export const MOBILE_MEDIA_QUERY = '(max-width: 1060px)'

/**
 * Desktop side rails need two 300px cards plus their gutters. Keep the existing
 * 1880px threshold so the central page retains enough room on desktop, including
 * 1920px screens with classic scrollbars. Below it the rails are not requested
 * or rendered. Keep this in sync with circus.css.
 */
export const SIDE_RAIL_MEDIA_QUERY = '(min-width: 1880px)'
